@if (params.valueFormatted == "_???addRow???_") {
    <button pButton type="button" class="p-button-text" icon="fas fa-plus" (click)="addRow()"></button>
}
@else {
    @switch (column.cellType) {
        @case (_TableCellType.button) {
            @for (button of params.value; track button) {
                @if (button != null && button.visible) {
                    <button pButton type="button" class="p-button-text" [icon]="button.icon" [pTooltip]="button.description" (click)="buttonClick($event, button)"></button>
                }
            }
        }
        @default {
            @if (getKeepHtml()) {
                <span #value appDynamicTooltip (onToolTip)="handleTooltip($event)" [innerHTML]="params.valueFormatted"></span>
            }
            @else {
                <span #value appDynamicTooltip (onToolTip)="handleTooltip($event)" >{{params.valueFormatted}}</span>
            }
        }
    }
    @if (mouseInside && params.colDef.context.table.actionButtons) {
        <button pButton type="button" class="action-button p-button-text" [icon]="'fas fa-bars'" (click)="actionButtonClick($event)"></button>
    }
}

